<template>
	<div>
		<div id="jan-may-self-prod-chart" style="height: 500px"></div>
		<div id="jun-dec-self-prod-chart" style="height: 500px"></div>
	</div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";


export default {
	name: "SupplyAndSelfProdChart",
	props: ['data'],
	data() {
		return {
			colors: this.$store.state.colors,
		}
	},
	mounted() {
		const chartIds = ['jan-may-self-prod-chart', 'jun-dec-self-prod-chart'];
		const valueFields = ['Prelievo', 'Autoproduzione'];
		const chartData = [[], []];

		this.data.values.forEach((item, index) => {
			const date = new Date(item.dateTime)

			let chartIndex = 0;
			if (date.getMonth() > 5) {
				chartIndex = 1;
			} else {
				chartIndex = 0;
			}
			chartData[chartIndex].push({
				Prelievo: item.values[0] ? parseFloat(item.values[0]) : null,
				Autoproduzione: item.values[1] ? parseFloat(item.values[1]) : null,
				date
			})
		})


		chartIds.forEach((id, index) => {
			var chart = am4core.create(id, am4charts.XYChart);

			chart.data = chartData[index];

			let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
			dateAxis.groupData = false;

			let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
			valueAxis.min = 0;

			for (let i = 0; i < 2; i++) {
				var seriesColor = this.colors[i];
				const series = chart.series.push(new am4charts.ColumnSeries());
				series.dataFields.valueY = valueFields[i];
				series.dataFields.dateX = "date";
				series.name = valueFields[i];
				series.stacked = true;
				series.data = chartData[index];
				series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";
				series.stroke = am4core.color(seriesColor);
				series.columns.template.fill = am4core.color(seriesColor);
			}

			chart.legend = new am4charts.Legend();
		})
	},
	methods: {
	},
	computed: {
		monthsNames() {
			return this.$store.state.utils.months;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/BillAudit/Charts/SupplyAndSelfProdChart.vue